import { IRole } from './../interfaces';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as fromModels from '@models';

import { moduleRoutes } from './urlmap';
import { ApplicationHttpClient } from './../http-client';

@Injectable()
export class RoleService {
  private httpOptions = {};
  private mapRoutes = moduleRoutes;

  constructor(
    private http: ApplicationHttpClient,
  ) {}

  getRoles(): Observable<fromModels.Role[]> {
    return this.http.Get(this.mapRoutes.list).pipe(
      map(roles => roles['results']),
      catchError((err: HttpErrorResponse) => throwError(err))
    );
  }

  getRole(id: number): Observable<any> {
    return this.http.Get(`${this.mapRoutes.list}${id}/`);
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return 'Something bad happened; please try again later.';
  }
}
